module.exports = __webpack_public_path__ + "static/media/grand_mum_talking_02.02692b64.gif";